// ../Dossier/Network_call.js
import axios from "axios";
import { config } from "../../Network_Calls/config";

const BASE = process.env.REACT_APP_SERVER_URL || "";

/* existing dossier helpers kept as-is */

const postDossierDetails = async (implId, id, dossierDetails) => {
  const response = await axios.post(
    BASE + "/dossier/postDossierDetails",
    {
      implId: implId,
      id: id,
      dossierDetails: dossierDetails,
    },
    {
      ...config(),
    }
  );
  return response;
};

const getDossierDetails = async (implId, id, journey_type) => {
  const response = await axios.post(
    BASE + "/dossier/getDossierDetails",
    {
      implId: implId,
      id: id,
      journey_type: journey_type,
    },
    {
      ...config(),
    }
  );
  return response;
};

const deleteKeyDetail = async ({ id }) => {
  const response = await axios.delete(BASE + "/dossier/deleteKeyDetails", {
    ...config(),
    data: { id },
  });
  return response;
};

const postDossierActionPlan = async (actionPlans, dossierId, external_id) => {
  const response = await axios.post(
    BASE + "/dossier/postDossierActionPlan",
    {
      actionPlan: actionPlans,
      dossierId: dossierId,
      external_id: external_id,
    },
    {
      ...config(),
    }
  );
  return response;
};

const getDossierActionPlan = async (dossierId) => {
  const response = await axios.post(
    BASE + "/dossier/getDossierActionPlan",
    {
      dossierId: dossierId,
    },
    {
      ...config(),
    }
  );

  return response;
};

const markActionPlanDone = async (id) => {
  const response = await axios.put(
    BASE + "/dossier/markActionPlanDone",
    {
      id: id,
    },
    {
      ...config(),
    }
  );

  return response;
};

const deleteActionPlan = async (id) => {
  const response = await axios.delete(BASE + "/dossier/deleteActionPlan", {
    ...config(),
    data: { id },
  });
  return response;
};

const getDossierTagUsersList = async (implId) => {
  const response = await axios.post(
    BASE + "/dossier/getDossierTagUsersList",
    {
      implId: implId,
    },
    {
      ...config(),
    }
  );
  return response;
};

const linkVisitHistoryUpdate = async (id) => {
  const response = await axios.post(
    BASE + "/dossier/linkVisitHistoryUpdate",
    {
      linkId: id,
      event: "Dossier Link",
    },
    {
      ...config(),
    }
  );
  return response;
};

const linkTagMembersFetch = async (id) => {
  const response = await axios.post(
    BASE + "/dossier/linkTagMembersFetch",
    {
      implId: id,
    },
    {
      ...config(),
    }
  );
  return response;
};

/* -------------------------------
   New: contact dossier progress APIs
   ------------------------------- */

/**
 * Get progress for a single external id (backwards compatible).
 * Expects: POST /dossier/getContactDossierProgress with { implId, id }
 * Response: { ok: true, progress: 100 } or { ok:false, error: "..." }
 */
const getContactProgress = async (implId, externalId) => {
  const response = await axios.post(
    BASE + "/dossier/getContactDossierProgress",
    {
      implId: implId,
      id: externalId,
    },
    {
      ...config(),
    }
  );
  return response;
};

/**
 * Batch fetch progress for multiple external ids.
 * Expects: POST /dossier/getContactDossierProgressBatch with { implId, ids: [...] }
 * Recommended response shape: { ok: true, result: { "<externalId>": 100, "<externalId2>": 66, "<externalId3>": null } }
 * (use null where no dossier exists)
 */
const getContactProgressBatch = async (implId, ids = []) => {
  const response = await axios.post(
    BASE + "/dossier/getContactDossierProgressBatch",
    {
      implId: implId,
      ids: ids,
    },
    {
      ...config(),
    }
  );
  return response;
};



export {
  postDossierDetails,
  getDossierDetails,
  deleteKeyDetail,
  postDossierActionPlan,
  getDossierActionPlan,
  deleteActionPlan,
  getDossierTagUsersList,
  linkVisitHistoryUpdate,
  linkTagMembersFetch,
  getContactProgress,
  getContactProgressBatch,
  markActionPlanDone,
};
